import styled, { css } from "styled-components"
import { Card } from "antd"

interface CardComponentProps {
  active?: boolean
}

export const cardTimerStyles = {
  padding: "0.35rem",
  width: "1.5rem",
  zIndex: "1",
  height: "1.5rem",
  color: "white",
  border: "none",
  borderRadius: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "0.5rem",
  cursor: "pointer",
  transition: "background-color 250ms",
}


export const tag = {
  borderRadius: ".25rem",
  padding: ".25rem",
  fontSize: ".7rem",
  color: "white",
  width: "auto",
}

export const tagsWrapper = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginTop: ".5rem",
  marginBottom: ".5rem",
  height: "1.75rem",
  gap: ".25rem",
  flexWrap: "wrap",
}

export const cardTitle = {
  margin: "0",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
}

export const CardWrapper = styled.div`
  outline: none;
`

export const cardStyles = {
  padding: "20px",
  margin: "0",
  zIndex: "100",
}

export const CardComponent = styled(Card)<CardComponentProps>`
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
  outline: none;

  width: 17.5rem;

  section {
    .card-timer {
      opacity: 0;
    }
  }

  :hover {
    section {
      .assignee-button {
        opacity: 1;
      }
    }
  }

  :hover {
    section {
      .card-timer {
        opacity: 1;
      }
    }
  }

  :active {
    box-shadow: none;
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
  }

  ${(props) =>
    props.active &&
    css`
      box-shadow: none;

      :active::after {
        opacity: 1;
      }

      ::after {
        content: "";
        opacity: 0;
        transition: 200ms;
        display: block;
        position: absolute;
        background: #fafafb;
        border: solid #07c5b7 1px;
        border-radius: 0.5rem;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    `}
`
